module.exports = __webpack_public_path__ + "img/bq.0901c11b.svg";